import { render } from "./BarraIzquierda.vue?vue&type=template&id=57f2bfeb"
import script from "./BarraIzquierda.vue?vue&type=script&lang=js"
export * from "./BarraIzquierda.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__